import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import categoryReducer from './slices/categorySlice';
import productReducer from './slices/productSlice';
import orderReducer from './slices/orderSlice';
import crmReducer from './slices/crmSlice';
import rechargeReducer from './slices/rechargeSlice';
import customerReducer from './slices/customerSlice';
import onboardingReducer from './slices/onboardingSlice';
import purchaseReducer from './slices/purchaseSlice';
import inventoryReducer from './slices/inventorySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    category: categoryReducer,
    product: productReducer,
    order: orderReducer,
    crm: crmReducer,
    recharge: rechargeReducer,
    customer: customerReducer,
    onboarding: onboardingReducer,
    purchase: purchaseReducer,
    inventory: inventoryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore Firebase objects in actions
        ignoredActions: ['auth/auth/fulfilled', 'auth/auth/fulfilled', 'crm/syncExternalAPIData/fulfilled'],
        ignoredPaths: ['auth.user', 'crm.users'],
      },
    }),
});

export default store;
